module.exports = __webpack_public_path__ + "media/intro_300x300.9d589738.mp4";